module.exports = "../fonts/HelveticaNeueLTW01-75Bold.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/HelveticaNeueLTW01-75Bold.ttf
// module id = 72SL
// module chunks = 1